(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initFaq(root) {
    (root || document).querySelectorAll('[data-premium-faq]').forEach(function (group) {
      if (group.__premiumFaqInit) return;
      group.__premiumFaqInit = true;

      group.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-premium-faq-trigger]');
        if (!trigger || !group.contains(trigger)) return;
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));
        if (!panel) return;
        var opening = trigger.getAttribute('aria-expanded') !== 'true';

        if (opening && group.getAttribute('data-allow-multiple') !== 'true') {
          group.querySelectorAll('[data-premium-faq-trigger][aria-expanded="true"]').forEach(function (other) {
            if (other === trigger) return;
            other.setAttribute('aria-expanded', 'false');
            var otherPanel = document.getElementById(other.getAttribute('aria-controls'));
            if (otherPanel) otherPanel.hidden = true;
          });
        }

        trigger.setAttribute('aria-expanded', String(opening));
        if (opening) {
          panel.hidden = false;
          if (!prefersReducedMotion() && panel.animate) {
            panel.animate([{ opacity: 0, transform: 'translateY(-6px)' }, { opacity: 1, transform: 'none' }], { duration: 180, easing: 'ease-out' });
          }
        } else if (!prefersReducedMotion() && panel.animate) {
          var animation = panel.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 120, easing: 'ease-in' });
          animation.addEventListener('finish', function () { panel.hidden = true; }, { once: true });
        } else {
          panel.hidden = true;
        }
      });
    });
  }

  function initStickyQuantity(root) {
    (root || document).querySelectorAll('[data-sticky-quantity]').forEach(function (control) {
      if (control.__premiumQuantityInit) return;
      control.__premiumQuantityInit = true;

      var value = control.querySelector('[data-sticky-quantity-value]');
      var minus = control.querySelector('[data-sticky-quantity-minus]');
      var plus = control.querySelector('[data-sticky-quantity-plus]');

      function activeInput() {
        var business = document.documentElement.getAttribute('data-shopping-mode') === 'business';
        return document.getElementById(business ? 'BusinessProductQuantity' : 'RetailProductQuantity');
      }

      function sync() {
        var input = activeInput();
        if (!input || !value) return;
        value.textContent = input.value;
        var minimum = Number(input.min) || 1;
        if (minus) minus.disabled = Number(input.value) <= minimum;
      }

      function change(direction) {
        var input = activeInput();
        if (!input) return;
        var step = Number(input.step) || 1;
        var minimum = Number(input.min) || 1;
        var maximum = Number(input.max) || Infinity;
        var next = Math.min(maximum, Math.max(minimum, (Number(input.value) || minimum) + (direction * step)));
        input.value = next;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      }

      if (minus) minus.addEventListener('click', function () { change(-1); });
      if (plus) plus.addEventListener('click', function () { change(1); });
      ['RetailProductQuantity', 'BusinessProductQuantity'].forEach(function (id) {
        var input = document.getElementById(id);
        if (input) {
          input.addEventListener('input', sync);
          input.addEventListener('change', sync);
        }
      });
      var productInfo = document.querySelector('[data-product-info]');
      if (productInfo) productInfo.addEventListener('variant:change', function () { requestAnimationFrame(sync); });
      sync();
    });
  }

  function initStickyFastCheckout(root) {
    (root || document).querySelectorAll('[data-fastrr-buy-now]').forEach(function (button) {
      if (button.__fastCheckoutInit) return;
      button.__fastCheckoutInit = true;

      button.addEventListener('click', function () {
        var attempts = 0;
        var maximumAttempts = 40;

        function openFastCheckout() {
          var fastCheckout = document.querySelector('.shiprocket-headless .sr-headless-checkout');
          if (fastCheckout && !fastCheckout.disabled) {
            fastCheckout.click();
            return;
          }

          attempts += 1;
          if (attempts < maximumAttempts) {
            window.setTimeout(openFastCheckout, 100);
            return;
          }

          var checkoutHost = document.querySelector('.shiprocket-headless');
          if (checkoutHost) checkoutHost.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        openFastCheckout();
      });
    });
  }

  function init(root) {
    initFaq(root);
    initStickyQuantity(root);
    initStickyFastCheckout(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
